import { FormControl, Grid, TextField, Box, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

function TextAreaWithCounter({
    label, name, id, maxLength, handleChange, onChange, value, error, helperText,
    // `variant`/`rows`/`sx` são opt-in — o default ('standard', 2 linhas, sem
    // sx extra) fica 100% inalterado para os consumidores existentes
    // (customers/vehicles/services Form.js, Settings.js, admin/plans —
    // fora de escopo do redesign). Só a Ordem de Serviço (`orderData.js`,
    // Nova Ordem — DESIGN-SYSTEM.md §5.5 "Floating label"/`ff-textarea`)
    // passa `variant="outlined"` + `sx` próprio hoje.
    variant = 'standard',
    rows = 2,
    sx,
    // Legenda abaixo do contador — opt-in, default preserva 100% o texto
    // fixo original ("Descreva os detalhes do serviço") para todo consumidor
    // que não passar a prop (customers/vehicles/services Form.js, admin/plans,
    // service_order/service_quotes) — só `pages/Settings.js` (Banner/Termos
    // da Ordem de Serviço, DESIGN-SYSTEM.md §6.4) passa uma legenda própria,
    // já que "Descreva os detalhes do serviço" não faz sentido nesse contexto.
    captionText = 'Descreva os detalhes do serviço',
}) {
    const theme = useTheme();
    const remainingChars = maxLength - (value ? value.length : 0);
    const isNearLimit = remainingChars <= 20;
    const isAtLimit = remainingChars === 0;

    // Usa onChange se fornecido, senão usa handleChange
    const changeHandler = onChange || handleChange;

    const standardSx = {
        '& .MuiInputBase-input': {
            color: theme.palette.text.primary,
        },
        '& .MuiInputLabel-root': {
            color: theme.palette.text.secondary,
            fontWeight: 500
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.2)'
                : 'rgba(0,0,0,0.1)',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottomColor: theme.palette.primary.main,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: theme.palette.primary.main,
        },
    };

    return (
        <Box>
            <TextField
                fullWidth
                value={value || ''}
                label={label}
                placeholder={variant === 'outlined' ? ' ' : undefined}
                multiline
                rows={rows}
                name={name}
                id={id || "textarea"}
                onChange={changeHandler}
                error={error}
                helperText={helperText}
                inputProps={{ maxLength: maxLength }}
                size="small"
                variant={variant}
                sx={variant === 'outlined' ? sx : standardSx}
            />
            
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                mt: 0.5 
            }}>
                <Typography 
                    variant="caption" 
                    color={theme.palette.text.secondary}
                    sx={{ fontStyle: 'italic' }}
                >
                    {captionText}
                </Typography>
                
                <Chip
                    label={`${remainingChars}/${maxLength}`}
                    size="small"
                    sx={{
                        backgroundColor: isAtLimit 
                            ? 'error.light' 
                            : isNearLimit 
                                ? 'warning.light' 
                                : 'success.light',
                        color: isAtLimit 
                            ? 'error.contrastText' 
                            : isNearLimit 
                                ? 'warning.contrastText' 
                                : 'success.contrastText',
                        fontWeight: 600,
                        fontSize: '0.7rem',
                        height: 20
                    }}
                />
            </Box>
        </Box>
    );
}

export default TextAreaWithCounter;
